import { _ as t } from "../internals/export.js";
import { a as r } from "../internals/an-object.js";
import { a as o } from "../internals/a-possible-prototype.js";
import { o as e } from "../internals/object-set-prototype-of.js";
e && t({
  target: "Reflect",
  stat: !0
}, {
  setPrototypeOf: function setPrototypeOf(t, s) {
    r(t), o(s);
    try {
      return e(t, s), !0;
    } catch (t) {
      return !1;
    }
  }
});